/** Created by azhou on 2019/4/8.*/
<template>
  <div class="border rounded position-relative">
    <div class="border-bottom d-center-start">
      <div class="bg-base w-15 d-center pt-3 pb-3 mr-3">申请单位</div>{{withdrawDetail.store_name}}
    </div>
    <div class="border-bottom d-center">
      <div class="w-50 d-center-start">
        <div class="w-30 bg-base d-flex">
          <div class="border-right pl-4 pr-4 pt-4">打 款 账 户</div>
          <div class="w-100">
            <div class="border-bottom pt-2 pb-2 pl-3">户名</div>
            <div class="border-bottom pt-2 pb-2 pl-3">账号</div>
            <div class="pt-2 pb-2 pl-3">银行</div>
          </div>
        </div>
        <div class="w-70 text-left">
          <div class="border-bottom pt-2 pb-2 pl-3">杭州订单雨络科技有限公司</div>
          <div class="border-bottom pt-2 pb-2 pl-3">330 1040 1600 0437 1541</div>
          <div class="pt-2 pb-2 pl-3">杭州银行股份有限公司城东支行</div>
        </div>
      </div>
      <div class="w-50 d-center-start">
        <div class="w-30 bg-base d-flex">
          <div class="border-right pl-4 pr-4 pt-4">收 款 账 户</div>
          <div class="w-100">
            <div class="border-bottom pt-2 pb-2 pl-3">户名</div>
            <div class="border-bottom pt-2 pb-2 pl-3">账号</div>
            <div class="pt-2 pb-2 pl-3">银行</div>
          </div>
        </div>
        <div class="w-70 text-left">
          <div class="border-bottom pt-2 pb-2 pl-3">{{withdrawDetail.truename}}</div>
          <div class="border-bottom pt-2 pb-2 pl-3">{{withdrawDetail.card}}</div>
          <div class="pt-2 pb-2 pl-3">{{withdrawDetail.bank+withdrawDetail.branch}}</div>
        </div>
      </div>
    </div>
    <div class="border-bottom d-center">
      <div class="w-50 d-center-start">
        <div class="w-30 bg-base pt-3 pb-3 text-center">申请金额</div>
        <div class="w-70 text-left pl-3" style="box-sizing: border-box">{{withdrawDetail.money/100 | formatMoney}} 元</div>
      </div>
      <div class="w-50 d-center-start">
        <div class="w-30 bg-base pt-3 pb-3 text-center">到账金额</div>
        <div class="w-70 text-left pl-3" style="box-sizing: border-box">{{withdrawDetail.money_end/100 | formatMoney}} 元</div>
      </div>
    </div>
    <div class="d-center">
      <div class="w-50 d-center-start">
        <div class="w-30 bg-base pt-3 pb-3 text-center">打款状态</div>
        <div class="w-70 text-left pl-3" :class="[withdrawDetail.status ? 'text-success' : 'text-danger']"
             style="box-sizing: border-box">{{withdrawDetail.status ? '已打款' : '待打款'}}</div>
      </div>
      <div class="w-50 d-center-start">
        <div class="w-30 bg-base pt-3 pb-3 text-center">打款时间</div>
        <div class="w-70 text-left pl-3" style="box-sizing: border-box">
          <span v-if="withdrawDetail.do_time>0">{{withdrawDetail.do_time | formatTimestamp(1)}}</span>
          <span v-else>-</span>
        </div>
      </div>
    </div>
    <img src="/images/public/seal.png" class="seal" v-show="withdrawDetail.status"/>
    <el-table v-if="withdrawDetail.arr.length > 0" :data="withdrawDetail.arr" class="w-100 mt-3">
      <el-table-column prop="order_no" label="订单号" />
      <el-table-column label="打款时间">
        <template slot-scope="scope">{{scope.row.do_time | formatTimestamp(1)}}</template>
      </el-table-column>
      <el-table-column label="申请金额">
        <template slot-scope="scope">&yen; {{scope.row.money / 100 | formatMoney}}</template>
      </el-table-column>
      <el-table-column label="实际打款">
        <template slot-scope="scope">&yen; {{scope.row.money_end / 100 | formatMoney}}</template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import { mapGetters,mapState } from 'vuex'

  export default {
    name: 'WithdrawDetail',
    computed: {
      ...mapState(['withdrawDetail']),
      ...mapGetters(['storeInfo'])
    },
  }
</script>
<style lang="scss" scoped>
  .seal{
    position: absolute;
    bottom: 10px;
    right: 100px;
    width: 100px;
    height: 100px;
  }
</style>
